// Components/Modules
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VCalendar from "v-calendar";
import VueNoty from "vuejs-noty";
import CKEditor from "@ckeditor/ckeditor5-vue";
import * as firebase from "firebase";
// Styles
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import "bulma/css/bulma.css";
import "vuejs-noty/dist/vuejs-noty.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VCalendar);
Vue.use(VueNoty);
Vue.use(CKEditor);

const config = {
  apiKey: process.env.VUE_APP_KEY,
  authDomain: process.env.VUE_APP_DOMAIN,
  databaseURL: process.env.VUE_APP_DB,
  projectId: process.env.VUE_APP_ID,
  storageBucket: process.env.VUE_APP_STORAGE,
  messagingSenderId: process.env.VUE_APP_MSG_ID,
  appId: process.env.VUE_APP_FB_APP_ID
};

firebase.initializeApp(config);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
